import { GET_SUB_FAMILIA, ADD_SUB_FAMILIA, MODIFY_SUB_FAMILIA, DELETE_SUB_FAMILIA, UPDATE_SUB_FAMILIA } from '../constants/action_types';

const initialState = {
    subFamiliaList: [],
    isLoading: false
};

export default function (state = initialState, action) {


    switch (action.type) {
        case GET_SUB_FAMILIA:
        
            return {
                subFamiliaList: [],
                isLoading: true
            };

        case GET_SUB_FAMILIA + "_SUCCESS":
        
            return {
                subFamiliaList: action.payload.data,
                isLoading: false
            };

        case ADD_SUB_FAMILIA:

            const newArr = [...state.subFamiliaList, action.payload]
            return {
                subFamiliaList: newArr,
                isLoading: false
            };

        case MODIFY_SUB_FAMILIA:

           return {
                subFamiliaList: state.subFamiliaList.map((p) => {
                    if (p.id !== action.payload.id) return p;
                    else return action.payload
                }),
                isLoading: false
            };
        case DELETE_SUB_FAMILIA:

            return {
                subFamiliaList: state.subFamiliaList.filter(p => p.id !== action.payload.id),
                isLoading: false
            };

        case UPDATE_SUB_FAMILIA + "_SUCCESS":

            return state;

        default:

            return state;
    }
}